import { render, staticRenderFns } from "./ModalViewLocalidad.vue?vue&type=template&id=64b936d2&scoped=true&"
import script from "./ModalViewLocalidad.vue?vue&type=script&lang=ts&"
export * from "./ModalViewLocalidad.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewLocalidad.vue?vue&type=style&index=0&id=64b936d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b936d2",
  null
  
)

export default component.exports